import {ChecklistTemplateKind} from '@domain/hroc-checklists'

import {type ChecklistConfig, StepperLayoutType, useWidgetTranslation} from '../hooks'

import {useKilnCheckSheetStepsConfig} from './useKilnCheckSheetStepsConfig'
import {useTakeFiveStepsConfig} from './useTakeFiveStepsConfig'

export const useChecklistConfig = (
  checklistTemplateKind: ChecklistTemplateKind | undefined
): ChecklistConfig | undefined => {
  const {t} = useWidgetTranslation()

  if (checklistTemplateKind === undefined) {
    return undefined
  }

  switch (checklistTemplateKind) {
    case ChecklistTemplateKind.TakeFive:
      return {
        layout: StepperLayoutType.Horizontal,
        useStepsConfig: useTakeFiveStepsConfig,
        showSubmitInHeader: false,
        title: t('takeFive.pageTitle')
      }
    case ChecklistTemplateKind.KilnCheckSheet:
      return {
        layout: StepperLayoutType.SideMenu,
        useStepsConfig: useKilnCheckSheetStepsConfig,
        showSubmitInHeader: true,
        title: t('kilnCheckSheet.pageTitle')
      }
    default:
      throw new Error(`Unknown checklistTemplateKind: ${checklistTemplateKind}`)
  }
}
